import type { ReactNode } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/useAuthStore'
import UpdateBanner from './UpdateBanner'
import { Button } from './ui'

const navItems = [
  { to: '/doklady', label: 'Doklady' },
  { to: '/import', label: 'Import XML' },
  { to: '/export', label: 'Export ZIP' },
  { to: '/cesty', label: 'Kniha jízd' },
  { to: '/vozidla', label: 'Vozidla' },
]

const adminItems = [
  { to: '/admin/users', label: 'Uživatelé' },
  { to: '/admin/nastaveni', label: 'Nastavení' },
]

export default function Layout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuthStore()
  const navigate = useNavigate()

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `rounded-lg px-3 py-2 text-sm font-medium transition ${
      isActive ? 'bg-brand-600 text-white' : 'text-slate-600 hover:bg-slate-100'
    }`

  return (
    <div className="min-h-screen">
      <UpdateBanner />
      <header className="border-b border-slate-200 bg-white">
        {/* Na mobilu se řádek zalomí: logo s odhlášením zůstane nahoře a menu
            se posune pod ně a vodorovně posouvá, místo mačkání do dvou řádků. */}
        <div className="mx-auto flex max-w-6xl flex-wrap items-center gap-x-6 gap-y-2 px-4 py-3">
          <span className="text-lg font-bold text-brand-700">mis</span>
          <div className="order-last -mx-4 w-full overflow-x-auto px-4 md:order-none md:mx-0 md:w-auto md:overflow-visible md:px-0">
            <nav className="flex w-max items-center gap-1 md:w-auto">
              {navItems.map((i) => (
                <NavLink key={i.to} to={i.to} className={linkClass}>
                  {i.label}
                </NavLink>
              ))}
              {user?.isAdmin &&
                adminItems.map((i) => (
                  <NavLink key={i.to} to={i.to} className={linkClass}>
                    {i.label}
                  </NavLink>
                ))}
            </nav>
          </div>
          <div className="ml-auto flex items-center gap-3">
            <span className="hidden text-sm text-slate-500 sm:inline">{user?.email}</span>
            <Button
              variant="ghost"
              onClick={async () => {
                await logout()
                navigate('/login')
              }}
            >
              Odhlásit
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-6">{children}</main>
    </div>
  )
}
